<template>
  <div
    class="footer"
    :class="{
      'footer--scrollable': $route.meta.isScrollable,
      'footer--info-hidden': $route.meta.isFooterInfoHidden,
    }"
  >
    <div class="footer__inner">
      <a class="footer__email" href="mailto:avalon.theresistance@gmail.com">
        Contact Us
      </a>

      <avl-paypal-donation class="footer__donate" />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('utils', ['getScrolledFromTop']),
    },
  };
</script>

<style scoped lang="scss">
  .footer {
    width: 100%;
    height: $footer-height;
    padding: 16px;
    //
    position: fixed;
    left: 0;
    bottom: 0;
    pointer-events: none;
    display: flex;
    align-items: center;

    & > * {
      pointer-events: all;
    }

    &--scrollable {
      position: static;
    }

    &__inner {
      display: flex;
      align-items: center;
      transition: opacity 400ms;
    }

    &--info-hidden &__inner {
      pointer-events: none;
      opacity: 0;
    }

    &__email {
      color: #ffffff;
      text-decoration: underline;
      //
      font-size: 10px;
      @include phone-lg() {
        font-size: 14px;
      }
    }

    &__donate {
      display: flex;
      align-items: center;
      margin-left: 16px;
    }
  }
</style>
